import React, { Fragment, useState } from "react";
import { Card } from "react-bootstrap";
import {
  Checkbox,
  Button,
  Box,
  Switch,
  FormGroup,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core"; import { FormControlLabel, IconButton, TextField, MenuItem } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import { buttonStyle } from "../../../Style/ManualStyle";
import { useDispatch, useSelector } from "react-redux";
import { getAllJobs, setBackendJobs } from "../../../Utils/actions";
import { loadingOn } from "../../../Utils/utils";
import cogoToast from "cogo-toast";

const TeamNotify = () => {
  const dispatch = useDispatch();
  const [form, setForm] = useState({
    msHost: "",
    msPort: "",
    msApiKey: "",
    msServerUrl: "",
  });
  const [error, setError] = useState({
    msHost: "",
    msPort: "",
    msApiKey: "",
    msServerUrl: "",
  });
  const textFields = {
    margin: "5px",
    padding: "10px",
    height: "70px",
    gap: "15px",
  };
  const textFld = { margin: "5px", padding: "0px", display: "flex" };
  const switchtextFld = { marginLeft: "10px", display: "block" };
  const [openConfirm, setOpenConfirm] = useState(false);

  const handleOpenConfirm = () => {
    setOpenConfirm(true);
  };
  const handleSetting = (e) => {
    let value = e.target.value === "0" ? "" : e.target.value;
    setForm({ ...form, [e.target.name]: value });
  };

  const handleChange = (e) => {
    setError({ ...error, [e.target.name]: "" });
    setForm({ ...form, [e.target.name]: e.target.value.toString() });
  };

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  const handleConfirmSubmit = (e) => {
    handleSubmit(e);
    handleCloseConfirm();
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    let newErrors = { ...error };

    // Validate all fields
    if (!form.msHost.trim()) newErrors.msHost = "Host is required";
    if (!form.msPort.trim()) newErrors.msPort = "Port is required";
    if (!form.msApiKey.trim()) newErrors.msApiKey = "API Key is required";
    if (!form.msServerUrl.trim()) newErrors.msServerUrl = "Server URL is required";

    // Update error state with all errors
    setError(newErrors);

    // Check for any errors
    const hasErrors = Object.values(newErrors).some((err) => err !== "");
    if (hasErrors) {
      console.log("Errors found:", newErrors); // Debugging
      return;
    }

    // Proceed with submission
    const data = [
      {
        propertyKey: "yh.server.integration.msteams.host",
        propertyValue: form.msHost,
      },
      {
        propertyKey: "yh.server.integration.msteams.port",
        propertyValue: form.msPort,
      },
      {
        propertyKey: "yh.server.integration.msteams.apiKey",
        propertyValue: form.msApiKey,
      },
      {
        propertyKey: "yh.server.integration.msteams.serverUrl",
        propertyValue: form.msServerUrl,
      },
    ];

    try {
      dispatch(loadingOn());
      dispatch(setBackendJobs(data));
    } catch (err) {
      cogoToast.error("Not successful");
      console.error("Submission error:", err); // Debugging
    }
  };


  return (
    <Fragment>
      <Card
        className={"shadow-none w-100 backendjobs-card"}
        style={{
          backgroundColor: "#333333",
          padding: "15px",
          overflow: "auto",
          height: "89vh",
          border: "none",
          borderRadius: "unset",
        }}
      >
        <Card.Body
          className={"backendjobs_content"}
          style={{
            borderRadius: "0.25rem",
            background: "#fff",
            overflow: "auto",
            backgroundColor: "#242424",
          }}
        >
          <div
            className="col-md-10 backfill-form"
            style={{ paddingTop: "5px", paddingLeft: "5px" }}
          >
            <Box
              component="form"
              className="addUserBox"
              onSubmit={(e) => e.preventDefault()}
              noValidate
              autoComplete="off"
            >
              <div className="textBoxes d-block">
                <div className="main1">
                  <h6
                    style={{
                      backgroundColor: "#333333",
                      fontWeight: "700",
                      padding: "10px",
                      color: "#c7c7c7",
                      marginBottom: "20px",
                    }}
                  >
                    MS Teams
                  </h6>

                  <div
                    className="col-md-12 d-flex align-items-center"
                    style={textFields}
                  >

                    <div
                      className="server-info app-txt"
                      style={{ switchtextFld, flex: "0 0 200px" }}
                    >
                      <TextField
                        type="text"
                        name="msHost"
                        label="Host"
                        value={form.msHost}
                        onFocus={handleSetting}
                        onChange={handleChange}
                        required
                        error={!!error.msHost}
                        helperText={error.msHost}
                        size="small"
                      />
                    </div>

                    <div
                      className="app-txt"
                      style={{ textFld, flex: "0 0 200px" }}
                    >
                      <TextField
                        type="number"
                        name="msPort"
                        label="Port"
                        value={form.msPort}
                        onFocus={handleSetting}
                        onChange={handleChange}
                        required
                        error={!!error.msPort}
                        helperText={error.msPort}
                        size="small"
                      />
                    </div>
                                       <div
                    className="app-txt"
                    style={{ textFld, flex: "0 0 200px" }}
                  >
                      <TextField
                        type="text"
                        name="msApiKey"
                        label="Api Key"
                        value={form.msApiKey}
                        onFocus={handleSetting}
                        onChange={handleChange}
                        required
                        error={!!error.msApiKey}
                        helperText={error.msApiKey}
                        size="small"
                      />
                    </div>
                    <div
                      className="app-txt"
                      style={{ textFld, flex: "0 0 200px" }}
                    >
                      <TextField
                        type="text"
                        name="msServerUrl"
                        label="Server Url"
                        value={form.msServerUrl}
                        onFocus={handleSetting}
                        onChange={handleChange}
                        required
                        error={!!error.msServerUrl}
                        helperText={error.msServerUrl}
                        size="small"
                      />
                    </div>

                  </div>
                </div>
                <div className="main2">
                  <h6
                    style={{
                      backgroundColor: "#333333",
                      fontWeight: "700",
                      padding: "10px",
                      color: "#c7c7c7",
                      marginBottom: "20px",
                      opacity: 0.5,
                    }}
                  >
                    Email Notifications
                  </h6>

                </div>
              </div>
              <Button
                className="submit-btn"
                type="button"
                startIcon={<SaveIcon />}
                style={{
                  ...buttonStyle,
                  width: "100px",
                  left: "15px",
                  marginTop: "10px",
                }}
                onClick={handleOpenConfirm}
              >
                Save
              </Button>
            </Box>
          </div>
        </Card.Body>
      </Card>
      <Dialog
        open={openConfirm}
        onClose={handleCloseConfirm}
        aria-labelledby="confirm-dialog-title"
      >
        <DialogTitle
          id="confirm-dialog-title"
          style={{
            backgroundColor: "#464545fb",
            color: "#c7c7c7",
          }}
        >
          Confirm Save
        </DialogTitle>

        <DialogContent>
          Are you sure you want to save the changes?
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleCloseConfirm}
            variant="contained"
            color="secondary"
            style={{ ...buttonStyle }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmSubmit}
            color="primary"
            variant="contained"
            startIcon={<SaveIcon />}
            style={{
              ...buttonStyle,
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment >
  );
};

export default TeamNotify;
